import { SearchRounded } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";

function SearchField({ searchQuery, setSearchQuery, colors, theme }) {
  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder="Search..."
      value={searchQuery}
      onChange={(e) => {
        setSearchQuery(e.target.value);
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      InputProps={{
        sx: {
          fontFamily: theme.typography.fontFamily,
          color: colors.contrast_text_dark,
          fontSize: "12px",
          minWidth: "250px",
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchRounded
              style={{
                color: colors.text_secondary,
                width: "16px",
                height: "16px",
              }}
            />
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
          borderColor: colors.divider2,
        },
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "0.5px solid " + colors.divider2,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "0.5px solid " + colors.grey_500,
          },
        },

        "& .MuiInputBase-input::placeholder": {
          color: colors.text_primary,
        },
        width: "100%",
        "& .MuiInputBase-root": { height: "32px" },
      }}
    />
  );
}

export default SearchField;
